import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const UploadDropArea = styled(Box, {
  shouldForwardProp: prop => prop !== 'centered',
})<{ centered?: boolean }>(({ theme, centered }) => ({
  border: `2px dashed ${theme.palette.primary.main}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(4),
  textAlign: 'center',
  cursor: 'pointer',
  backgroundColor: theme.palette.action.hover,
  transition: 'border-color 0.3s ease',
  '&:hover, &.dragover': {
    borderColor: theme.palette.primary.dark,
    backgroundColor: theme.palette.action.selected,
  },
  '& > .MuiSvgIcon-root': {
    fontSize: 48,
    color: theme.palette.primary.main,
  },
  ...(centered && {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
  }),
}));
